import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"cancel\"><title>ic-cancel</title><g id=\"cancel_cancel\"><g id=\"cancel_expanded-4\" data-name=\"expanded\"><path d=\"M96,32a64,64,0,1,0,64,64A64,64,0,0,0,96,32Zm29.3,82.37A8,8,0,1,1,114,125.63L96,107.55l-18,18.08A8,8,0,1,1,66.7,114.37l18-18.18L66.32,77.63A8,8,0,0,1,77.68,66.37L96,84.83l18.32-18.46a8,8,0,0,1,11.36,11.26L107.27,96.19Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/cancel.svg
// module id = 1842
// module chunks = 0